import React, { useState } from "react";

import ColorSection from "./ColorSelection";

function BrandingSection() {
  return (
    <div className="customizer-body custom-scrollbar p-3">
      <ColorSection />
    </div>
  );
}

export default BrandingSection;
